// src/countdown/src/Countdown.tsx
import * as React from "react";
import ReactCountdown from "react-countdown";

// src/countdown/src/Countdown.css.ts
var container = "Countdown__1w26eub1";
var digitsContainer = "Countdown__1w26eub4";
var messageContainer = "Countdown__1w26eub3";
var messageStyle = "Countdown__1w26eub2";
var numbers = "Countdown__1w26eub5";
var root = "Countdown__1w26eub0";
var texts = "Countdown__1w26eub6";

// src/countdown/src/Countdown.tsx
function Countdown({
  date,
  message,
  url,
  urlTarget = "_self",
  textColor,
  paddingTop = 16,
  paddingBottom = 16,
  labelDays,
  labelHours,
  labelMinutes,
  labelSeconds
}) {
  const renderer = ({
    days,
    hours,
    minutes,
    seconds
  }) => {
    const formattedDays = days === 0 ? null : days.toString().padStart(2, "0");
    const formattedHours = hours === 0 && days === 0 ? null : hours.toString().padStart(2, "0");
    const formattedMinutes = minutes === 0 && hours === 0 && days === 0 ? null : minutes.toString().padStart(2, "0");
    const formattedSeconds = seconds.toString().padStart(2, "0");
    return /* @__PURE__ */ React.createElement("div", null, formattedDays === null && formattedHours === null && formattedMinutes === null && formattedSeconds === "00" && message ? /* @__PURE__ */ React.createElement(React.Fragment, null, url ? /* @__PURE__ */ React.createElement("div", { className: messageContainer }, /* @__PURE__ */ React.createElement(
      "a",
      {
        href: url,
        target: urlTarget,
        rel: "noreferrer",
        className: messageStyle,
        style: { color: textColor }
      },
      message
    )) : /* @__PURE__ */ React.createElement("div", { className: messageContainer }, /* @__PURE__ */ React.createElement("p", { className: messageStyle, style: { color: textColor } }, message))) : /* @__PURE__ */ React.createElement("div", { className: container }, formattedDays && /* @__PURE__ */ React.createElement("div", { className: digitsContainer }, /* @__PURE__ */ React.createElement("p", { className: numbers }, formattedDays), /* @__PURE__ */ React.createElement("span", { className: texts }, labelDays)), formattedHours && /* @__PURE__ */ React.createElement("div", { className: digitsContainer }, /* @__PURE__ */ React.createElement("p", { className: numbers }, formattedHours), /* @__PURE__ */ React.createElement("span", { className: texts }, labelHours)), formattedMinutes && /* @__PURE__ */ React.createElement("div", { className: digitsContainer }, /* @__PURE__ */ React.createElement("p", { className: numbers }, formattedMinutes), /* @__PURE__ */ React.createElement("span", { className: texts }, labelMinutes)), formattedSeconds && /* @__PURE__ */ React.createElement("div", { className: digitsContainer }, /* @__PURE__ */ React.createElement("p", { className: numbers }, formattedSeconds), /* @__PURE__ */ React.createElement("span", { className: texts }, labelSeconds))));
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: root,
      style: {
        color: textColor,
        paddingTop,
        paddingBottom
      }
    },
    /* @__PURE__ */ React.createElement(ReactCountdown, { date, renderer, zeroPadTime: 0 })
  );
}
export {
  Countdown as default
};
